import {z} from 'zod';

export const Alpha3Schema = z.string();
export type Alpha3 = z.infer<typeof Alpha3Schema>;
